var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGoogleSlides = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 29,
  height: 40,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#google-slides_svg__a)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "google-slides_svg__b",
  width: 29,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M17.807 0H2.67C1.201 0 0 1.21 0 2.69v34.065c0 1.48 1.202 2.69 2.671 2.69h23.148c1.47 0 2.671-1.21 2.671-2.69V10.758z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#google-slides_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F4B400",
  d: "M17.807 0H2.67C1.201 0 0 1.21 0 2.69v34.065c0 1.48 1.202 2.69 2.671 2.69h23.148c1.47 0 2.671-1.21 2.671-2.69V10.758l-6.232-4.483z"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "google-slides_svg__c",
  width: 29,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M17.807 0H2.67C1.201 0 0 1.21 0 2.69v34.065c0 1.48 1.202 2.69 2.671 2.69h23.148c1.47 0 2.671-1.21 2.671-2.69V10.758z"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#google-slides_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F1F1F1",
  d: "M20.032 17.93H8.458c-.734 0-1.335.604-1.335 1.344v11.654c0 .74.6 1.345 1.335 1.345h11.574c.735 0 1.336-.605 1.336-1.345V19.274c0-.74-.601-1.345-1.336-1.345m-.445 10.309H8.903v-6.276h10.684z"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "google-slides_svg__d",
  width: 29,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M17.807 0H2.67C1.201 0 0 1.21 0 2.69v34.065c0 1.48 1.202 2.69 2.671 2.69h23.148c1.47 0 2.671-1.21 2.671-2.69V10.758z"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#google-slides_svg__d)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#google-slides_svg__e)",
  d: "m18.588 9.97 9.902 9.97v-9.182z"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "google-slides_svg__f",
  width: 29,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M17.807 0H2.67C1.201 0 0 1.21 0 2.69v34.065c0 1.48 1.202 2.69 2.671 2.69h23.148c1.47 0 2.671-1.21 2.671-2.69V10.758z"
}))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#google-slides_svg__f)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FADA80",
  d: "M17.807 0v8.068a2.68 2.68 0 0 0 2.67 2.69h8.013z"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "google-slides_svg__g",
  width: 29,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M17.807 0H2.67C1.201 0 0 1.21 0 2.69v34.065c0 1.48 1.202 2.69 2.671 2.69h23.148c1.47 0 2.671-1.21 2.671-2.69V10.758z"
}))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#google-slides_svg__g)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.1,
  d: "M17.807 0v.224l10.46 10.534h.223z"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "google-slides_svg__h",
  width: 29,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M17.807 0H2.67C1.201 0 0 1.21 0 2.69v34.065c0 1.48 1.202 2.69 2.671 2.69h23.148c1.47 0 2.671-1.21 2.671-2.69V10.758z"
}))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#google-slides_svg__h)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.2,
  d: "M2.671 0C1.201 0 0 1.21 0 2.69v.224C0 1.434 1.202.224 2.671.224h15.136V0z"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "google-slides_svg__i",
  width: 29,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M17.807 0H2.67C1.201 0 0 1.21 0 2.69v34.065c0 1.48 1.202 2.69 2.671 2.69h23.148c1.47 0 2.671-1.21 2.671-2.69V10.758z"
}))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#google-slides_svg__i)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#BF360C",
  fillOpacity: 0.2,
  d: "M25.82 39.22H2.67C1.201 39.22 0 38.01 0 36.53v.225c0 1.48 1.202 2.69 2.671 2.69h23.148c1.47 0 2.671-1.21 2.671-2.69v-.224c0 1.48-1.202 2.69-2.67 2.69"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "google-slides_svg__j",
  width: 29,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M17.807 0H2.67C1.201 0 0 1.21 0 2.69v34.065c0 1.48 1.202 2.69 2.671 2.69h23.148c1.47 0 2.671-1.21 2.671-2.69V10.758z"
}))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#google-slides_svg__j)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#BF360C",
  fillOpacity: 0.1,
  d: "M20.478 10.758a2.68 2.68 0 0 1-2.672-2.69v.224a2.68 2.68 0 0 0 2.671 2.69h8.013v-.224z"
}))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#google-slides_svg__k)",
  d: "M17.807 0H2.67C1.201 0 0 1.21 0 2.69v34.065c0 1.48 1.202 2.69 2.671 2.69h23.148c1.47 0 2.671-1.21 2.671-2.69V10.758z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "google-slides_svg__k",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(45.9404 0 0 46.2572 .903 .784)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0.1
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "google-slides_svg__e",
  x1: 23.54,
  x2: 23.54,
  y1: 10.827,
  y2: 19.941,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BF360C",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BF360C",
  stopOpacity: 0.02
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "google-slides_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h29v40H0z"
})))));
export { SvgGoogleSlides as ReactComponent };
export default __webpack_public_path__ + "static/media/google-slides.93ef60a5.svg";